import { axiosInstance } from "./axiosInstance";

export const getTryout = async (filter: any) => {
	filter = Object.keys(filter).map(function (key) {
		return key + '=' + filter[key];
	}).join('&');
	return await axiosInstance.get(`/api/feature/membership/tryout/fetchUser?${filter}`);
}

export const startTryout = async (id: number) => {
	return await axiosInstance.get(`/api/feature/membership/tryout/start/${id}`);
}

export const endTryout = async (id: number) => {
	return await axiosInstance.get(`/api/feature/membership/tryout/end/${id}`);
}

export const submitAnswer = async (data: any) => {
	return await axiosInstance.post(`/api/feature/membership/tryout/submit-answer`, data)
}

export const getRanking = async (id: string) => {
	return await axiosInstance.get(`/api/feature/membership/tryout/ranking/${id}`);
}

export const getTryoutExplanation = async (tryoutId: string, questionId: string, triesId: string) => {
	return await axiosInstance.get(`/api/feature/membership/tryout/explanation/${tryoutId}/${questionId}/${triesId}`);
}

export const getTryoutHistory = async (id: string) => {
	return await axiosInstance.get(`/api/feature/membership/tryout/history/${id}`);
}

export const getTableScore = async (tryoutId: string, tries: string) => {
	return await axiosInstance.get(`/api/feature/membership/tryout/table-score/${tryoutId}/${tries}`);
}

export const getTryoutSummary = async (membershipId: string, params: any) => {
	const paramsString = Object.keys(params).map(function (key) {
		return key + '=' + params[key];
	}).join('&');
	return await axiosInstance.get(`/api/feature/membership/tryout/summary-tryout/${membershipId}?${paramsString}`);
}

export const getQuizSummary = async (membershipId: string) => {
	return await axiosInstance.get(`/api/feature/membership/tryout/summary-quiz/${membershipId}`);
}

export const getTryoutSummaryAnalysis = async (tryoutId: string, tries: string) => {
	return await axiosInstance.get(
		`/api/feature/membership/tryout/summary-analysis/${tryoutId}/${tries}`
	);
}

export const getTryoutMiniProgress = async (tryoutId: string) => {
	return await axiosInstance.get(
		`/api/feature/membership/tryout/mini-progress/${tryoutId}`
	);
}